<template>
    <div class="mb-2">
        <v-breadcrumbs
            class="mt-0 mb-0 pt-0 pb-0"
            :items="items"></v-breadcrumbs>
    </div>
</template>
<script>
export default {
    props: ['items']
}
</script>
<!-- breadcrumbs items format -->
<!--
    [
      {
        disabled: boolean
        exact: boolean
        href: string
        link: boolean
        text: string | number
        to: string | object
      }
    ]
-->



// WEBPACK FOOTER //
// resources/assets/js/components/BreadCrumbs.vue